module.exports = __webpack_public_path__ + "img/paypal.4a9d8f40.svg";